import newRequest from '@/utils/new-request';

const baseFinanceURL = process.env.VUE_APP_FINANCE;

// 揽收每日应收统计 分页
export const apiStatisticsPage = (data) => {
  return newRequest({
    method: 'POST',
    url: '/statistics/page',
    data
  });
};

// 揽收每日应收统计 刷新数据
export const apiStatisticsAgainStatistics = (time) => {
  return newRequest({
    method: 'GET',
    url: `/statistics/againStatistics?time=${time}`
  });
};

// 揽收每日应收统计 导出文件
export const apiStatisticsExport = (data) => {
  return newRequest({
    method: 'POST',
    url: '/statistics/export',
    data
  });
};

/**
 * 应收看板 获取token
 * @param {*} type
 *        5: 财务应收看板-总览
 *        6: 财务应收看板-业务总览明细
 *        7: 财务应收看板-客户总览明细
 * @returns
 */
export const getDashboardParams = (type) => {
  return newRequest({
    method: 'get',
    url: `/bi/api/createEmbedPageToken?type=${type
      }`,
    baseURL: baseFinanceURL
  });
};
